/* Pettly theme – storefront behaviour */
(function () {
  'use strict';
  var P = window.Pettly || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Money ---------- */
  var sample = P.moneySample || '$1.00';
  function money(cents) {
    var amount = (cents / 100).toFixed(2);
    if (sample.indexOf('1,00') > -1) amount = amount.replace('.', ',');
    return sample.replace(/1[.,]00/, amount).replace(/\s?[A-Z]{3}$/, '');
  }
  function moneyWithCurrency(cents) {
    var amount = (cents / 100).toFixed(2);
    if (sample.indexOf('1,00') > -1) amount = amount.replace('.', ',');
    return sample.replace(/1[.,]00/, amount);
  }

  /* ---------- Toast ---------- */
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { t.classList.remove('show'); }, 2400);
  }

  /* ---------- Accordions ---------- */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('.acc-head');
    if (!head) return;
    head.parentElement.classList.toggle('open');
  });

  /* ---------- Mobile menu ---------- */
  var menuBtn = $('#menuToggle'), menu = $('#MobileMenu');
  if (menuBtn && menu) {
    menuBtn.addEventListener('click', function () {
      var open = menu.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = $('#cartDrawer'), overlay = $('#overlay');
  function openCart() { if (!drawer) return; drawer.classList.add('show'); overlay.classList.add('show'); drawer.setAttribute('aria-hidden', 'false'); }
  function closeCart() { if (!drawer) return; drawer.classList.remove('show'); overlay.classList.remove('show'); drawer.setAttribute('aria-hidden', 'true'); }
  var openBtn = $('#cartOpenBtn');
  if (openBtn && drawer && !document.body.classList.contains('template-cart')) {
    openBtn.addEventListener('click', function (e) { e.preventDefault(); refreshCart().then(openCart); });
  }
  if ($('#cartCloseBtn')) $('#cartCloseBtn').addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); closePopup(); } });

  function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function sizedImg(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function renderCart(cart) {
    var items = $('#cartItems'), foot = $('#cartFoot'), count = $('#cartCount');
    if (count) { count.textContent = cart.item_count; count.style.display = cart.item_count ? 'flex' : 'none'; }
    if (!items) return;
    if (!cart.item_count) {
      items.innerHTML = $('#cartEmptyTpl').innerHTML;
      foot.style.display = 'none';
      return;
    }
    foot.style.display = 'block';
    items.innerHTML = cart.items.map(function (item, i) {
      var line = i + 1;
      var variant = item.product_has_only_default_variant ? '' : (item.variant_title || '');
      var price = item.final_line_price < item.original_line_price
        ? '<span class="cart-compare">' + money(item.original_line_price) + '</span>' + money(item.final_line_price)
        : money(item.final_line_price);
      return '<div class="cart-line">' +
        (item.image ? '<img src="' + sizedImg(item.image, 160) + '" alt="' + escapeHtml(item.product_title) + '">' : '') +
        '<div class="cart-line-info">' +
          '<h4><a href="' + item.url + '">' + escapeHtml(item.product_title) + '</a></h4>' +
          '<div class="variant">' + escapeHtml(variant) + '</div>' +
          '<div class="cart-line-bottom">' +
            '<div class="qty-control">' +
              '<button type="button" data-line="' + line + '" data-q="' + (item.quantity - 1) + '" aria-label="Decrease">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-line="' + line + '" data-q="' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
            '</div><span>' + price + '</span>' +
          '</div>' +
          '<button class="cart-remove" type="button" data-line="' + line + '" data-q="0">Remove</button>' +
        '</div></div>';
    }).join('');

    var lever = $('#cartLever');
    if (lever) {
      var unlocked = cart.item_count >= (P.bulkThreshold || 2);
      lever.textContent = unlocked ? (P.bulkUnlockedText || '') : (P.bulkLockedText || '');
    }
    var disc = $('#cartDiscounts');
    if (disc) {
      var apps = cart.cart_level_discount_applications || [];
      var html = apps.map(function (a) {
        return '<div class="cart-discount"><span>' + escapeHtml(a.title) + '</span><span>-' + money(a.total_allocated_amount) + '</span></div>';
      }).join('');
      var lineSavings = cart.items.reduce(function (s, it) { return s + (it.original_line_price - it.final_line_price); }, 0);
      if (lineSavings > 0) html += '<div class="cart-discount"><span>Bundle savings</span><span>-' + money(lineSavings) + '</span></div>';
      disc.innerHTML = html;
    }
    $('#cartSubtotal').textContent = moneyWithCurrency(cart.total_price);
  }

  function refreshCart() {
    return fetch((P.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () {});
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var b = e.target.closest('[data-line]');
      if (!b) return;
      b.disabled = true;
      fetch((P.routes.cartChange || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(b.dataset.line), quantity: Math.max(0, Number(b.dataset.q)) })
      }).then(function (r) { return r.json(); }).then(renderCart).catch(function () { b.disabled = false; });
    });
    refreshCart();
  }

  function addToCart(form) {
    return fetch((P.routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        return data;
      });
    });
  }

  /* ---------- Product page ---------- */
  var pdp = $('[data-pdp]');
  if (pdp) {
    var product = JSON.parse($('[data-product-json]', pdp).textContent);
    var form = $('form[data-product-form]', pdp);
    var idInput = $('[data-variant-id]', pdp);
    var qtyInput = $('[data-qty-input]', pdp);
    var addBtn = $('[data-add]', pdp);
    var buyBtn = $('[data-buy-now]', pdp);
    var mainImg = $('#pdpImg');
    var colorIndex = -1;
    product.options.forEach(function (o, i) {
      var name = (typeof o === 'string' ? o : o.name || '').toLowerCase();
      if (name.indexOf('colo') > -1) colorIndex = i;
    });
    var current = product.variants.find(function (v) { return String(v.id) === idInput.value; }) || product.variants[0];
    var selected = current.options.slice();

    /* ----- Swipe gallery: slide 1 = colour shot, then shared supporting photos ----- */
    var gallery = $('[data-gallery]', pdp);
    var track = gallery ? $('[data-track]', gallery) : null;
    var slides = track ? $$('.pdp-slide', track) : [];
    var dots = $$('[data-dot]', pdp);
    var thumbs = $$('[data-thumb]', pdp);
    var prevBtn = gallery ? $('[data-prev]', gallery) : null;
    var nextBtn = gallery ? $('[data-next]', gallery) : null;
    var leadThumbImg = thumbs.length ? $('img', thumbs[0]) : null;
    var colourMedia = {};
    try { var cmEl = $('[data-colour-media]', pdp); if (cmEl) colourMedia = JSON.parse(cmEl.textContent) || {}; } catch (e) { colourMedia = {}; }
    var defaultLead = gallery ? { src: gallery.dataset.defaultSrc, thumb: gallery.dataset.defaultThumb, alt: gallery.dataset.defaultAlt } : null;
    var activeSlide = 0;
    var lastColour = colorIndex > -1 ? current.options[colorIndex] : null;

    function setActive(i) {
      activeSlide = i;
      dots.forEach(function (d, n) { d.classList.toggle('active', n === i); });
      thumbs.forEach(function (t, n) { t.classList.toggle('active', n === i); });
      if (prevBtn) prevBtn.disabled = i <= 0;
      if (nextBtn) nextBtn.disabled = i >= slides.length - 1;
    }
    function goTo(i, smooth) {
      if (!track || !slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      setActive(i);
    }
    if (track) {
      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
          if (i !== activeSlide) setActive(i);
        }, 60);
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(activeSlide + 1, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(activeSlide - 1, true); }
      });
      window.addEventListener('resize', function () { goTo(activeSlide, false); });
      setActive(0);
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(activeSlide - 1, true); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(activeSlide + 1, true); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { goTo(n, true); }); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { goTo(n, true); }); });

    function fullUrl(src) { return src && src.indexOf('//') === 0 ? 'https:' + src : src; }
    function setLead(img) {
      if (!img || !img.src) return;
      if (mainImg) {
        mainImg.removeAttribute('srcset'); mainImg.removeAttribute('sizes');
        mainImg.src = fullUrl(img.src);
        if (img.alt) mainImg.alt = img.alt;
      }
      if (leadThumbImg && img.thumb) { leadThumbImg.removeAttribute('srcset'); leadThumbImg.src = fullUrl(img.thumb); }
      goTo(0, true);
    }
    function leadForVariant(v) {
      if (colorIndex > -1 && colourMedia[v.options[colorIndex]]) return colourMedia[v.options[colorIndex]];
      if (v.featured_image && v.featured_image.src) return { src: sizedImg(v.featured_image.src, 1600), thumb: sizedImg(v.featured_image.src, 150) };
      return defaultLead;
    }

    function update() {
      var v = product.variants.find(function (x) { return x.options.every(function (o, i) { return o === selected[i]; }); });
      if (!v) {
        v = product.variants.find(function (x) { return colorIndex > -1 && x.options[colorIndex] === selected[colorIndex]; }) || product.variants[0];
        selected = v.options.slice();
      }
      current = v;
      idInput.value = v.id;
      $$('.opt-group', pdp).forEach(function (g) {
        var idx = Number(g.dataset.optionIndex);
        var lbl = $('[data-option-label]', g); if (lbl) lbl.textContent = selected[idx];
        $$('[data-value]', g).forEach(function (b) { b.classList.toggle('active', b.dataset.value === selected[idx]); });
      });
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      $('[data-price]', pdp).textContent = moneyWithCurrency(v.price);
      var cmp = $('[data-compare]', pdp), save = $('[data-save]', pdp);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        cmp.textContent = money(v.compare_at_price);
        save.textContent = 'Save ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
        save.style.display = '';
      } else { cmp.textContent = ''; save.style.display = 'none'; }
      var nameEl = $('[data-variant-name]', pdp);
      if (nameEl && colorIndex > -1 && $('.opt-group[data-option-index="' + colorIndex + '"]', pdp)) nameEl.textContent = v.options[colorIndex];
      if (v.available) {
        addBtn.textContent = 'Add to cart: ' + money(v.price * qty);
        addBtn.removeAttribute('aria-disabled'); buyBtn.removeAttribute('aria-disabled');
      } else {
        addBtn.textContent = 'Sold out';
        addBtn.setAttribute('aria-disabled', 'true'); buyBtn.setAttribute('aria-disabled', 'true');
      }
      var colourNow = colorIndex > -1 ? v.options[colorIndex] : null;
      if (colourNow !== lastColour) { lastColour = colourNow; setLead(leadForVariant(v)); }
      if (window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    $$('.opt-group [data-value]', pdp).forEach(function (b) {
      b.addEventListener('click', function () {
        var idx = Number(b.closest('.opt-group').dataset.optionIndex);
        selected[idx] = b.dataset.value;
        update();
      });
    });
    $$('[data-qty]', pdp).forEach(function (b) {
      b.addEventListener('click', function () {
        var q = Math.min(99, Math.max(1, (parseInt(qtyInput.value, 10) || 1) + Number(b.dataset.qty)));
        qtyInput.value = q; update();
      });
    });
    qtyInput.addEventListener('change', update);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn.getAttribute('aria-disabled') === 'true') return;
      addBtn.setAttribute('aria-disabled', 'true');
      addToCart(form).then(function () {
        toast('Added to cart');
        return refreshCart();
      }).then(openCart).catch(function (err) { toast(err.message); })
        .finally(function () { if (current.available) addBtn.removeAttribute('aria-disabled'); });
    });
    buyBtn.addEventListener('click', function () {
      if (buyBtn.getAttribute('aria-disabled') === 'true') return;
      buyBtn.setAttribute('aria-disabled', 'true');
      addToCart(form).then(function () {
        var f = document.createElement('form');
        f.method = 'post'; f.action = P.routes.cart || '/cart';
        f.innerHTML = '<input type="hidden" name="checkout" value="1">';
        document.body.appendChild(f); f.submit();
      }).catch(function (err) { toast(err.message); buyBtn.removeAttribute('aria-disabled'); });
    });
  }

  /* ---------- Collection category pills ---------- */
  var pills = $('[data-cat-pills]');
  if (pills) {
    var grid = $('[data-filter-grid]');
    pills.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cat]'); if (!b) return;
      $$('[data-cat]', pills).forEach(function (x) { x.classList.toggle('active', x === b); });
      var cat = b.dataset.cat;
      $$('.card', grid).forEach(function (c) { c.style.display = (cat === 'All' || c.dataset.type === cat) ? '' : 'none'; });
    });
  }

  /* ---------- Email popup ---------- */
  var popup = $('#popupOverlay');
  function storage(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function closePopup() { if (!popup) return; popup.classList.remove('show'); storage('pettly_popup_seen', '1'); }
  if (popup) {
    var posted = /customer_posted=true/.test(window.location.search);
    if ($('[data-popup-success]', popup) && posted) {
      popup.classList.add('show'); storage('pettly_popup_seen', '1');
    } else if (!storage('pettly_popup_seen') && !posted) {
      setTimeout(function () { popup.classList.add('show'); }, (P.popupDelay || 4) * 1000);
    }
    $('#popupClose').addEventListener('click', closePopup);
    popup.addEventListener('click', function (e) { if (e.target === popup) closePopup(); });
    var copy = $('#copyCodeBtn');
    if (copy) copy.addEventListener('click', function () {
      if (navigator.clipboard) navigator.clipboard.writeText(copy.dataset.code);
      toast('Code copied');
    });
  }
})();
